import { ConfigurationTypes } from "../../vendor_core/core/src/const/ConfigurationTypes";
import ILocalConfig from "../../vendor_core/core/src/managers/contracts/configurations/ILocalConfig";
import { version } from "../../package.json";
import App from "../../vendor_core/core/src/App";
import BetModel from "../../vendor_core/core/src/model/BetModel";
import JackpotsModel from "../../vendor_core/src/model/JackpotsModel";
import BURPaytableModel from "../src/models/BURPaytableModel";
import BURJackpotsModel from "../src/models/BURJackpotsModel";
import BURGameModel from "../src/models/BURGameModel";

class VendorLocalConfig implements ILocalConfig {
    private gameName: string = "";
    type: ConfigurationTypes = ConfigurationTypes.LOCAL;
    overwritePatterns: { overwriteString: string; pattern: () => string }[] = [
        {
            overwriteString: "{RTP}",
            pattern: () => `${BURGameModel.game_rtp.toFixed(2).toString()}%`
        },
        {
            overwriteString: "{MIN_BET}",
            pattern: () => BURGameModel.min_bet.toString()
        },
        {
            overwriteString: "{MAX_BET}",
            pattern: () => BURGameModel.max_bet.toString()
        },
        {
            overwriteString: "{GAMENAME}",
            pattern: () => this.gameName
        },
        {
            overwriteString: "{game_version}",
            pattern: () => version
        },
        {
            overwriteString: "jackpotFee",
            pattern: () => {
                return JackpotsModel.jackpotFee + `${BetModel.currency.symbol}`;
            }
        },
        {
            overwriteString: "{game_datestamp}",
            //@ts-ignore
            pattern: () => App.config.versionDate
        },
        {
            overwriteString: "{CURRENCY_SIGN1}",
            pattern: () => BetModel.currency.symbol
        }, //{{CURRENCY_SIGN1}}{{MIN_BET}}
        {
            overwriteString: "{CURRENCY_SIGN2}",
            pattern: () => BetModel.currency.symbol
        }, //{{CURRENCY_SIGN2}}{{MAX_BET}}
        {
            overwriteString: "{SIZE_BUCKET_1}",
            pattern: () => BURPaytableModel.size_buckets[0]
        },
        {
            overwriteString: "{SIZE_BUCKET_2}",
            pattern: () => BURPaytableModel.size_buckets[1]
        },
        {
            overwriteString: "{SIZE_BUCKET_3}",
            pattern: () => BURPaytableModel.size_buckets[2]
        },
        {
            overwriteString: "{SIZE_BUCKET_4}",
            pattern: () => BURPaytableModel.size_buckets[3]
        },
        {
            overwriteString: "{SIZE_BUCKET_5}",
            pattern: () => BURPaytableModel.size_buckets[4]
        },
        {
            overwriteString: "{SIZE_BUCKET_6}",
            pattern: () => BURPaytableModel.size_buckets[5]
        },
        {
            overwriteString: "{SIZE_BUCKET_7}",
            pattern: () => BURPaytableModel.size_buckets[6]
        },
        {
            overwriteString: "{SIZE_BUCKET_8}",
            pattern: () => BURPaytableModel.size_buckets[7]
        },
        {
            overwriteString: "{SIZE_BUCKET_9}",
            pattern: () => BURPaytableModel.size_buckets[8].slice(0, 2)
        },
        {
            overwriteString: "{MINI_JACKPOT_MULTIPLIER}",
            pattern: () =>
                BURJackpotsModel.jackpots_config!.MINI.value.toString()
        },
        {
            overwriteString: "{MINOR_JACKPOT_MULTIPLIER}",
            pattern: () =>
                BURJackpotsModel.jackpots_config!.MINOR.value.toString()
        },
        {
            overwriteString: "{MEDIUM_JACKPOT_MULTIPLIER}",
            pattern: () =>
                BURJackpotsModel.jackpots_config!.MEDIUM.value.toString()
        },
        {
            overwriteString: "{MAJOR_JACKPOT_MULTIPLIER}",
            pattern: () =>
                BURJackpotsModel.jackpots_config!.MAJOR.value.toString()
        },
        {
            overwriteString: "{MEGA_JACKPOT_MULTIPLIER}",
            pattern: () =>
                BURJackpotsModel.jackpots_config!.MEGA.value.toString()
        }
    ];
}

export default new VendorLocalConfig();
